module.exports = __webpack_public_path__ + "static/media/ic_no_service.52239425.png";